import React, {Component} from 'react';

//import Counter from './Counter';
import PopupFooter from './PopupFooter';
import tag from './Analytics';


class MoreInfo extends Component {

  constructor(props) {
    super(props);
    tag('moreinfo');
  }

  render() {
    return (
      <div className="gp-popup gp-popup-moreinfo">
        <div className="gp-close-icon" onClick={this.props.onClose}>
          <span className="icon">
            <i className="fa fa-window-close"></i>
          </span>
        </div>
        <div className="gp-content">
          <h1 className="title">
            <span className="gp-subtitle-1">En savoir plus</span>
          </h1>
          <div className="content">
          <p>
              Le 21 février 2020 des militant·es de Greenpeace commençaient symboliquement <a href="https://www.greenpeace.fr/action-demantelement-de-la-centrale-nucleaire-de-tricastin/" target="_blank">le démontage de la centrale nucléaire du Tricastin</a> pour alerter sur son vieillissement et exiger sa fermeture au plus tôt.
            </p>
            <p>
              Suite à cette action, 34 activistes vont être jugé·es au tribunal de grande instance de Valence. <b>Leur procès se tiendra le 29 juin</b>. Ces femmes et ces hommes ont pourtant agi au nom de l’intérêt général, pour dénoncer des risques réels.
            </p>
            <p>
              Les réacteurs français ont été conçus et testés pour durer 40 années. Au-delà, les conséquences du vieillissement des centrales sont imprévisibles. Au cours de l’année 2020, 12 réacteurs, dont 2 à Tricastin, ont atteint 40 ans d’ancienneté. Mais EDF tente d’imposer la prolongation de la durée de vie de ces réacteurs d’au moins dix ans, en y réalisant des travaux coûteux et pourtant insuffisants.
            </p>
            <p>
              Afin de garantir la sécurité des habitant-es, il faut que dès maintenant démarre le processus de fermeture des vieux réacteurs comme celui de Tricastin. Des décisions urgentes doivent être prises pour préparer, anticiper et accompagner du mieux possible ces fermetures inéluctables.
            </p>
            <p>
              Plutôt que de juger les lanceurs et lanceuses d’alerte, il est temps de faire le procès du nucléaire.
              {/* Plus d’infos sur <a href="https://40anscasuffit.greenpeace.fr" target="_blank">40anscasuffit.greenpeace.fr</a> */}
            </p>



          </div>
          <p className="gp-legal">
          Cette carte est éditée et hébergée par Greenpeace France. Rendez-vous sur le site de Greenpeace France pour en savoir plus sur le&nbsp;<a
              target="_blank"
              href="https://www.greenpeace.fr/copyright/"
              rel="noopener noreferrer">Copyright</a>&nbsp;
            et les&nbsp;
            <a
              target="_blank"
              href="https://www.greenpeace.fr/mentions-legales/"
              rel="noopener noreferrer">
              Conditions générales d’utilisation
            </a>.

          </p>
          <PopupFooter/>
        </div>
      </div>
    )
  }
}

export default MoreInfo;
